// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"dcc159a0","638":"d3b08d5a","766":"de0fa8bd","800":"201dcbe6","871":"9d8707d4","969":"04558610"}[chunkId] + ".chunk.js";
};